import React, { useContext, useEffect } from "react";
import styles from "./styles/beneficiary.module.css";
import { UserData } from "../../../Context/DataContext";
import { selectLogo } from "./selectLogo";
import { revokeAccess } from "../../../Utils/beneficiary";
import { useState } from "react";
import Loading from "../../Loading/Loading";
import blueCurve from "./styles/img/piority1_curve.png";
import lightBlueCurve from "./styles/img/piority2_curve.png";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import backgroundImage from "./styles/img/piority1_background.png";
import UploadAvatar from "./uploadAvatar";
import editIcon from "./styles/img/edit_icon.svg";
import ApprovalModal from "../Partner Approval/ApprovalModal";
import { isPendingApproval, needsReview } from "../../../Utils/partnerApproval";
import { getPartner } from "../Partner Sharing/PartnerSharing";

function Beneficiary({ onEdit, beneficiary, priority }) {
  const userData = UserData();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.InheritanceTree.beneficiary
  );
  // const [benefAssets, setBenefAssets] = useState([]);

  const partnerReadOnly = Boolean(userData.partnerReadOnly);

  const benefAssets = [];

  /*
    Which assets this beneficiary inherits, read from whichever side of the
    relation is available.

    The customer's own view reads it off the asset, as it always has.
    The partner's cannot:  is encrypted with the customer's
    key as one blob, so the server has no way to strip the beneficiaries a
    partner was not given and withholds the field entirely. The same relation
    from the beneficiary's side is server-readable, so that is the one filtered
    and sent -- and it already contains only shared assets.
  */
  userData?.UserData?.assets.map((asset, i) => {
    const linked = partnerReadOnly
      ? beneficiary?.visible_assets?.includes(asset?.asset_id)
      : asset?.beneficiaries?.includes(beneficiary?.user_id);
    if (linked) {
      benefAssets.push(asset);
    }
  });

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.InheritanceTree.beneficiary);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const customerBeneficiary = userData?.CustomerBeneficiary?.filter(
    (e) => e.user_id === beneficiary.user_id
  )[0];

  const isRed =
    customerBeneficiary?.status === "active" ||
    customerBeneficiary?.status === "pending";
  const hasAccessed = customerBeneficiary?.accessed;
  const [modal, setModal] = useState();

  /*
    Created by the partner and not yet approved. The card still appears -- the
    customer has to be able to find it -- but it is marked, and until they
    approve it the beneficiary inherits nothing and is told nothing.
  */
  /*
    Two different things, and the node needs both.

    `awaitingApproval` is "the partner created this person and you have not
    accepted them yet" -- which is what the approval interstitial is about,
    and what the button below the node offers.

    `waiting` is the wider question the MARK answers: is anything about this
    person waiting on you. A beneficiary the partner has merely suggested a
    change to is already in the tree and inherits normally; nothing needs
    approving before they count. But the customer still has something to
    look at, so the node is outlined and badged -- and opening the person is
    where that change is answered, not the interstitial.
  */
  const awaitingApproval = isPendingApproval(beneficiary);
  const waiting = needsReview(beneficiary);
  const [reviewing, setReviewing] = useState(false);
  const partner = getPartner(userData);
  const approvalContent =
    websiteCurrentLang?.content?.User?.PartnerApproval?.PartnerApproval;

  const handleRevoke = (beneficiary_id) => {
    setModal(<Loading text={content?.beneficiaryText1} />);
    revokeAccess(beneficiary_id)
      .then(() => {
        setModal(<Loading text={content?.beneficiaryText1} />);
        userData.getCustomerBeneficiary();
        setTimeout(() => {
          setModal();
        }, 700);
      })
      .catch((e) => {
        setModal(<Loading text={"Something went wrong"} />);
        setTimeout(() => {
          setModal();
        }, 700);
      });
  };

  var backgroundColor;
  switch (Number(priority)) {
    case 0:
      backgroundColor = "#26323E";
      break;
    case 1:
      backgroundColor = "#023E8A";
      break;
    case 2:
      backgroundColor = "#0077B6";
      break;
    default:
      backgroundColor = "#023E8A";
  }

  const maxNameLength = 25;

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      {/*
        Outside the card, not inside it: .main is overflow:hidden so that the
        background artwork keeps the rounded corners, which clipped a badge
        sitting proud of the edge into a quarter circle. The wrapper around the
        card has no such clipping.

        Shown to the partner too, so they can see what is still waiting -- but
        only the customer can open the approval, because only the customer can
        give it.
      */}
      {waiting && (
        <button
          type="button"
          className={styles.approval_badge}
          /*
            It always opens something, which it did not before.

            One case takes the long way: a person the partner CREATED, seen
            by the CUSTOMER, opens the interstitial explaining what approving
            them means -- and that hands on to the same modal. Everything
            else goes straight there, because there is nothing to explain:
            the suggestion is answered inside the person's own modal, and
            this badge is the thing pointing at it.

            Including for the partner. The card's edit icon is already
            offered to them ungated -- what differs is that the modal opens
            read-only -- so a badge that stayed dead was the odd one out, not
            a safeguard. Until now it did nothing for them at all, nor for a
            customer looking at a merely-changed person: the comment here
            said a click on the node opens that modal, which is true of the
            CARD, while this badge deliberately sits outside it (.main clips
            it). The one element drawing the eye to a pending change was the
            one element that ignored being pressed.
          */
          onClick={() => {
            if (!partnerReadOnly && awaitingApproval) setReviewing(true);
            else onEdit();
          }}
          title={approvalContent?.partnerApprovalText16}
          aria-label={approvalContent?.partnerApprovalText12}
        >
          !
        </button>
      )}
      <div
        className={`${styles.main} ${
          waiting ? styles.awaiting_approval : ""
        }`}
        style={isRed ? { border: "1px solid rgba(178, 6, 6, 1)" } : {}}
      >

        <img
          src={backgroundImage}
          className={styles.backgroundImage}
          alt="background"
        />
        <div className={styles.curve}>
          <img
            style={{
              height: "100%",
            }}
            src={Number(priority) === 1 ? blueCurve : lightBlueCurve}
            alt="Curve"
          />
        </div>
        <div className={styles.nameContainer}>
          <span
            className={styles.name}
            style={
              beneficiary?.name.length > maxNameLength
                ? {
                    marginLeft: "62px",
                  }
                : {}
            }
          >
            {beneficiary?.name && beneficiary?.name.length > maxNameLength ? (
              <>{beneficiary.name.slice(0, maxNameLength) + "..."}</>
            ) : (
              <>{beneficiary?.name}</>
            )}
          </span>
          {/*
            Always offered, including to a partner. What it opens is the
            difference: their own unapproved draft opens editable, everything
            the customer wrote opens read-only. See canEditRecord.
          */}
          <img
            src={editIcon}
            onClick={onEdit}
            className={styles.editIcon}
            alt="edit icon"
          />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.contentLeft}>
            <UploadAvatar
              onEdit={onEdit}
              readOnly={partnerReadOnly}
              /*
                A partner granted this beneficiary's picture row may ask for
                it to change. The card gives them the click; the modal it
                opens is where the change becomes a proposal.
              */
              canRequestEdit={
                partnerReadOnly &&
                Boolean(userData.partnerPropose) &&
                beneficiary?.edit_picture_with_partner === true
              }
              modalTitle={dublicatedcontent?.edit_image}
              profile_avatar={beneficiary?.profile_avatar}
              profile_id={beneficiary?.user_id}
              uploadButtonStyles={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              previewContainerStyles={{
                left: "13px",
                top: "0px",
                // width: "80%",
                // backgroundColor: "white",
              }}
              // uploadTriggerStyles={{
              //   width: "85%",
              //   height: "105%",
              //   top: "-1px",
              // }}
            />
          </div>
          <div className={styles.right}>
            <div className={styles.rightTop}>
              {benefAssets.map((asset, i) => {
                if (benefAssets.length <= 9) {
                  const logo = selectLogo(asset?.asset_type);
                  return (
                    <div
                      key={asset.asset_id}
                      title={asset.asset_name}
                      className={styles.asset}
                    >
                      <div
                        className={styles.asset_logo}
                        style={{ backgroundImage: `url(${logo})` }}
                      ></div>
                    </div>
                  );
                } else if (benefAssets.length > 9) {
                  if (i === 8) {
                    return (
                      <div
                        key={asset.asset_id}
                        style={{
                          display: "flex",
                          alignItems: "center",

                          border: "none",
                          justifyContent: "center",
                        }}
                        className={styles.asset}
                      >
                        <span
                          style={{
                            fontSize: "22px",
                            marginBottom: "10px",
                          }}
                        >
                          ...
                        </span>
                      </div>
                    );
                  } else if (i > 8) return null;
                  const logo = selectLogo(asset?.asset_type);
                  return (
                    <div
                      key={asset.asset_id}
                      title={asset.asset_name}
                      className={styles.asset}
                    >
                      <div
                        className={styles.asset_logo}
                        style={{ backgroundImage: `url(${logo})` }}
                      ></div>
                    </div>
                  );
                }

                return null;
              })}
            </div>
            {/*
              Whether a beneficiary has been told has no sharing flag, so it is
              not sent and there is nothing here to state.
            */}
            <div className={styles.rightBottom} style={partnerReadOnly ? { display: "none" } : undefined}>
              {beneficiary?.awareness_status === "true" ||
              beneficiary?.awareness_status_2 === "true" ||
              beneficiary?.awareness_status_3 === "true" ? (
                <div
                  className={styles.aware}
                  style={{
                    transform: "translateY(5px)",
                  }}
                >
                  {content.beneficiaryText4}
                </div>
              ) : (
                <div
                  style={{
                    transform: "translateY(5px)",
                  }}
                  className={styles.not_aware}
                >
                  {content.beneficiaryText5}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/*
        The review call to action, in the same place the revoke banner uses --
        the two never appear together, since an unapproved beneficiary has no
        access to revoke.
      */}
      {awaitingApproval && !partnerReadOnly && (
        <div className={styles.approval_action}>
          <button
            type="button"
            className={styles.approval_button}
            onClick={() => setReviewing(true)}
          >
            {approvalContent?.partnerApprovalText12}
          </button>
        </div>
      )}

      {reviewing && (
        <ApprovalModal
          subject="beneficiary"
          partnerName={partner?.name}
          onClose={() => setReviewing(false)}
          onStart={() => {
            setReviewing(false);
            // Hands off to the ordinary edit modal, which offers Approve and
            // Delete in place of Save once it sees the record is pending.
            onEdit();
          }}
        />
      )}

      {/*
        Access revocation reads CustomerBeneficiary, which inside the partner's
        view is still the partner's own -- so it is not theirs to act on, and
        not shown.
      */}
      {isRed && !partnerReadOnly && (
        <div
          className={styles.revoke}
          style={{
            zIndex: "50",
          }}
        >
          <div className={styles.warning} />
          <div className={styles.beneficiary_access}>
            {hasAccessed ? content.beneficiaryText6 : content.beneficiaryText7}
          </div>
          <button
            onClick={() => handleRevoke(beneficiary.user_id)}
            className={styles.revoke_access_main}
          >
            {content.beneficiaryText8}
          </button>
        </div>
      )}
    </div>
  );
}

export default Beneficiary;
